import { requestHelpers } from '../../../helpers';

const actions = {
    GET_CURRENT_PODCAST: 'GET_CURRENT_PODCAST',
    SET_CURRENT_PODCAST: 'SET_CURRENT_PODCAST',
    GET_PODCASTS: 'GET_PODCASTS',
    SET_PODCASTS: 'SET_PODCASTS',
    GET_PODCAST_LOCATIONS: 'GET_PODCAST_LOCATIONS',
    SET_PODCAST_LOCATIONS: 'SET_PODCAST_LOCATIONS',
    GET_CURRENT_PODCAST_MODULES: 'GET_CURRENT_PODCAST_MODULES',
    SET_CURRENT_PODCAST_MODULES: 'SET_CURRENT_PODCAST_MODULES',
};

function getCurrentPodcast( podcastId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_CURRENT_PODCAST,
            podcastId,
        } );
        requestHelpers
            .authenticatedGetRequest( `/training/podcasts/${ podcastId }` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_CURRENT_PODCAST,
                    podcast: response.data,
                } );
            } );
    }
}

function getCurrentPodcastModules( podcastId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_CURRENT_PODCAST_MODULES,
            podcastId,
        } );
        requestHelpers
            .authenticatedGetRequest( `/training/podcasts/${ podcastId }/modules` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_CURRENT_PODCAST_MODULES,
                    modules: response.data,
                } );
            } );
    }
}

function getPodcasts( page ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_PODCASTS,
        } );

        requestHelpers
            .authenticatedGetRequest( '/training/podcasts', { page }  )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_PODCASTS,
                    podcasts: response.data,
                    pagination: response.meta,
                } );
            } );
    }
}

module.exports = {
    getCurrentPodcast,
    getPodcasts,
    getCurrentPodcastModules,
    actions
};



// WEBPACK FOOTER //
// src/client/actions/training/podcasts/podcasts.js